export const openWorkDetails = (workId: number) => {
  if (workId) {
    window.open(`/works/${workId}`, "_blank")
  }
}
